import { MENU_LINKS_CONFIG } from "page/wiki/main-screen/main-screen";
import { anchorLinkTarget } from "page/wiki/menu-helper";
import React from "react";

export function CommunityOfficials() {
  return (
    <div>
      <fieldset>
        <legend>More useful links</legend>

      <ul>
        <li>
          <a href="http://blog.betadwarf.com/">Developer Blog</a>
        </li>
        <li>
          <a href="https://twitter.com/BetaDwarf">Developer Twitter</a>
        </li>
        <li>
          <a href="https://www.reddit.com/r/MinionMasters/">Official Subreddit</a>
        </li>
        <li>
          <a href="Official Facebook">https://www.facebook.com/BetaDwarf/</a>
        </li>
        <li>
          <a href="https://steamcommunity.com/app/489520/discussions/">Official Steam forums</a>
        </li>

        <li>
          <a href="https://www.twitch.tv/playminionmasters">Dwarves on Twitch</a>
        </li>
        <li>
          <a href="https://minionmasters.gamepedia.com/">Game Wiki</a>
        </li>

        <li>
          <a href="https://docs.google.com/spreadsheets/d/1NPVhOJX1Ei2Wbq3AFbXWA1QgsDPRixgYtRbpjLliAj0/edit?usp=sharing">
            Data in overview
          </a>
        </li>

        <li>
          <a href="https://docs.google.com/document/d/1LPYzo106W6Bk2rn3ctre3zeMZ0CNJGwfKl9A5fkaU2A/edit">
            Official Troubleshooting
          </a>
        </li>

        <li>
          <h4>Discord Channels:</h4>
          <ul>
            <li>
          <a href="https://discord.com/invite/minionmasters">Main channel</a>

            </li>
<li>
          <a href="https://discordapp.com/invite/7cKFhkh">Russian</a>

</li>
<li>
          <a href="https://discord.gg/N9tgShA Italian: https://discord.gg/DYfpjCk">French</a>

</li>
<li>

          <a href="https://discord.gg/vyXXnua Brazilian: https://discord.gg/XCDUeDa">Polish</a>
</li>
<li>
          <a href="https://discord.gg/9nMvEqY Japanese: https://discord.gg/TGgw2ys">Vietnamese</a>

</li>

          <a href="https://discord.gg/5JM2pf4 Latin America: https://discord.gg/b8JY424">Spanish</a>
          </ul>
        </li>
      </ul>
      </fieldset>


    </div>
  );
}
